import { cn } from '@/utils/cn'

/**
 * Plain-text body rendered safely: React escapes the text (no HTML is ever interpreted); blank
 * lines become paragraphs and single line breaks are preserved.
 */
export function AnnouncementBody({ text, className }: { text: string; className?: string }) {
  const paragraphs = text.split(/\n{2,}/).filter((p) => p.trim() !== '')
  return (
    <div className={cn('space-y-3 text-sm leading-relaxed text-ink-soft', className)}>
      {paragraphs.map((p, i) => (
        <p key={i} className="whitespace-pre-line">
          {p}
        </p>
      ))}
    </div>
  )
}
